// extracted by mini-css-extract-plugin
export var animationContainer = "_hu-0";
export var asteriskIcon = "_hu-8";
export var conversationLeftSection = "_hu-4";
export var conversationListItem = "_hu-3";
export var conversationMiddleSection = "_hu-5";
export var conversationRightSection = "_hu-6";
export var detailsContent = "_hu-1";
export var listContainer = "_hu-7";
export var modalContent = "_hu-2";